var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Select"},[_c('select',{staticClass:"Select-Select",class:{ "fill-column": !_vm.label },domProps:{"value":_vm.selected},on:{"change":_vm.handleChange}},_vm._l((_vm.options),function(option,index){return _c('option',{key:index},[_vm._v(_vm._s(option))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }